var _defs, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWizardIconPurple(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22.936,
    height: 22,
    viewBox: "0 0 22.936 22",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs11"
  }, /*#__PURE__*/React.createElement("style", {
    id: "style9"
  }, ".a{fill:#483D8B;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M167.5,294.255a.344.344,0,0,1-.026-.038s-.007-.009-.009-.014l-.029-.05s0,0,0,0a.631.631,0,0,1-.055-.357.617.617,0,0,1,.245-.414l1.61-1.215a.629.629,0,0,1,.466-.119.652.652,0,0,1,.231.081.63.63,0,0,1,.183.164l3.051,4.054-2.611,1.967Zm15.488,16.175-1.612,1.215a.629.629,0,0,1-.877-.124l-9.11-12.1L174,297.453l9.11,12.1a.626.626,0,0,1-.124.877Zm-7.243-17.359v-1.379h1.921V289.77h1.379v1.921h1.919v1.379h-1.919v1.921h-1.379v-1.921ZM160.3,295.427v-1.12h1.558V292.75h1.12v1.558h1.558v1.12h-1.558v1.558h-1.12v-1.558Zm2.518,9.614v-1.712h2.385v-2.387h1.714v2.387h2.385v1.712h-2.385v2.387h-1.714v-2.387Z",
    transform: "translate(-160.303 -289.77)",
    id: "path13"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#483D8B",
      strokeWidth: 0.0331825,
      fillOpacity: 1
    },
    d: "M 17.387632,4.2473605 V 3.2850679 H 16.425339 15.463047 V 2.6048265 1.9245852 h 0.962292 0.962293 V 0.96229261 0 h 0.66365 0.66365 V 0.96229261 1.9245852 h 0.962293 0.962292 v 0.6802413 0.6802414 h -0.962292 -0.962293 v 0.9622926 0.9622926 h -0.66365 -0.66365 z",
    id: "path329"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#483D8B",
      fillOpacity: 1,
      strokeWidth: 0.0331825
    },
    d: "m 20.465949,21.910885 c -0.07179,-0.01882 -0.503734,-0.563299 -1.771986,-2.23366 -1.004174,-1.322557 -4.696212,-6.223295 -6.538964,-8.679694 L 11.157426,9.6677624 11.344173,9.5185398 c 0.240782,-0.1923998 1.8452,-1.3950188 2.13146,-1.5976717 l 0.219222,-0.155195 0.209398,0.273272 c 0.427137,0.5574313 4.638046,6.1413189 6.745851,8.9453549 1.379439,1.835082 2.192574,2.944687 2.216547,3.024702 0.04668,0.155799 0.01809,0.322603 -0.08032,0.468635 -0.07413,0.110006 -0.736893,0.63034 -1.495175,1.173863 -0.387066,0.277443 -0.396723,0.282071 -0.580694,0.278286 -0.102895,-0.0021 -0.212925,-0.01062 -0.244511,-0.0189 z",
    id: "path11635"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#483D8B",
      fillOpacity: 1,
      strokeWidth: 0.0331825
    },
    d: "M 9.7792519,7.8393665 C 9.1510308,7.0201403 7.3248267,4.5818679 7.2137196,4.4139737 7.1497153,4.3172568 7.1265808,4.2395451 7.1265808,4.1212642 c 0,-0.3018684 0.022622,-0.3256238 1.045384,-1.0977421 0.8415186,-0.6352915 0.9473098,-0.7007468 1.1325722,-0.7007468 0.2893571,0 0.2409835,-0.052154 1.600405,1.7254902 1.525698,1.9950744 1.883387,2.4900423 1.83353,2.5372258 -0.172875,0.1636066 -2.419085,1.8760472 -2.460813,1.8760472 -0.01171,0 -0.235996,-0.2799774 -0.4984071,-0.622172 z",
    id: "path11674"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#483D8B",
      fillOpacity: 1,
      strokeWidth: 0.0331825
    },
    d: "m 4.9110106,16.458522 v -1.19457 H 3.7164404 2.5218703 v -0.846154 -0.846154 h 1.1945701 1.1945702 v -1.19457 -1.19457 h 0.8461538 0.8461539 v 1.19457 1.19457 h 1.1945701 1.1945701 v 0.846154 0.846154 H 7.7978884 6.6033183 v 1.19457 1.19457 H 5.7571644 4.9110106 Z",
    id: "path11713"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#483D8B",
      fillOpacity: 1,
      strokeWidth: 0.0331825
    },
    d: "M 1.5595777,6.4208145 V 5.6410256 H 0.77978884 0 V 5.0935143 4.546003 H 0.77978884 1.5595777 V 3.7662142 2.9864253 H 2.107089 2.6546003 V 3.7662142 4.546003 H 3.4343891 4.214178 V 5.0935143 5.6410256 H 3.4343891 2.6546003 V 6.4208145 7.2006033 H 2.107089 1.5595777 Z",
    id: "path11752"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#483D8B",
      fillOpacity: 1,
      strokeWidth: 0.0331825
    },
    d: "M 17.387632,4.2473605 V 3.2850679 H 16.425339 15.463047 V 2.6048265 1.9245852 h 0.962292 0.962293 V 0.96229261 0 h 0.66365 0.66365 V 0.96229261 1.9245852 h 0.962293 0.962292 v 0.6802413 0.6802414 h -0.962292 -0.962293 v 0.9622926 0.9622926 h -0.66365 -0.66365 z",
    id: "path11791"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWizardIconPurple);
export default __webpack_public_path__ + "static/media/wizard_icon_purple.9f99dda79faf55a1f22c86e382e9ecd9.svg";
export { ForwardRef as ReactComponent };